import { observer } from 'mobx-react-lite'
import { Tabs } from 'shared/ui'
import { type AssignNumberCommonStore } from 'entities/Phone'
import type { INextButtonProps } from 'entities/Phone/ui/AssignNumberCommon/ui/NextButton/NextButton'
import { NewInboxPerNumber } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxPerNumber/NewInboxPerNumber'
import { ExistingInboxContent } from './ExistingInboxContent/ExistingInboxContent'
import { NewInboxContent } from './NewInboxContent/NewInboxContent'
import { AssignLater } from './AssignLater/AssignLater'
import styles from './styles.module.scss'

type IAssignNumberProps = {
  store: AssignNumberCommonStore
  nextButtonProps?: INextButtonProps
}

export const AssignNumberCommon = observer(({ store, nextButtonProps }: IAssignNumberProps) => {
  const {
    activeTabKey,
    tabs,
    setActiveTabKey,
    newInboxOnly,
    newInboxStore,
    nextButtonName,
    nextClick,
    loadingButton,
    hideSubmit,
    disabledButton,
  } = store

  const newInboxContentProps = {
    newInboxStore,
    nextButtonName,
    nextClick,
    loadingButton,
    disabledButton,
    hideSubmit,
  }

  if (newInboxOnly)
    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <NewInboxContent {...newInboxContentProps} />
        </div>
      </div>
    )

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <Tabs
          margin={'0 0 30px 0 '}
          activeTabKey={activeTabKey}
          handleSelectTab={(item) => setActiveTabKey(item.key)}
          tabs={tabs}
        />

        {activeTabKey === 'existing' && <ExistingInboxContent store={store} />}
        {activeTabKey === 'new' && <NewInboxContent {...newInboxContentProps} />}
        {activeTabKey === 'new_per_number' && <NewInboxPerNumber store={store} />}
        {activeTabKey === 'later' && (
          <AssignLater store={store} nextButtonProps={nextButtonProps} />
        )}
      </div>
    </div>
  )
})
